import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';
import {
  QUERY_CONSTANTS,
} from '@/constants';

import {
  DateTime,
} from 'luxon';

class SearchRepository {
  constructor() {
    this.calls_in_progress = {};
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getContacts(criteria) {
    const params = {
      matched_queries_query_type_id_list: [
        QUERY_CONSTANTS.TYPES.IGNORE_ALL_CONTACT_LIST,
        QUERY_CONSTANTS.TYPES.IGNORE_ENGAGE_CONTACT_LIST,
        QUERY_CONSTANTS.TYPES.IGNORE_CAMPAIGN_CONTACT_LIST,
        QUERY_CONSTANTS.TYPES.IGNORE_CUSTOM_CONTACT_LIST,
      ],
    };

    if (criteria.contact_id_list !== undefined) {
      params.contact_id_list = criteria.contact_id_list;
      params.limit = criteria.contact_id_list.length;
    }

    if (criteria.contact_quicksearch_list !== undefined) {
      params.contact_quicksearch_list = criteria.contact_quicksearch_list;
    }

    if (criteria.query_id_list !== undefined) {
      params.query_id_list = criteria.query_id_list;
    }

    if (criteria.has_linkedin !== undefined) {
      params.has_linkedin = criteria.has_linkedin;
    }

    if (criteria.has_email !== undefined) {
      params.has_email = criteria.has_email;
    }

    if (params.limit === undefined) {
      params.limit = 100;
    }

    const key = `getContacts:${btoa(JSON.stringify(params))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .post(
        `${configuration.api_host}/v1/aggregator-user-data/contacts`,
        params
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchAccountQuicksearch(params) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/accounts/quicksearch`,
      {
        params,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchAccount(params) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/accounts`,
      {
        params,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchAccountActive(params) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/accounts/active`,
      {
        params,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getAccountsAll(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/accounts/all`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getContactById(contact_id) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/contacts/${contact_id}`
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getAccountById(account_id) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/accounts/${account_id}`
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getContactsAll(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/contacts/search/full`,
      criteria
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getContactsActive(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/contacts/active`,
      criteria
    );

    return result.data;
  }

  // @TODO : Bad name
  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getWtfContactsActive(criteria) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/contacts/active`,
      {
        limit: 0,
        facet_list: [{
          field: "query_id_list",
          value_list: criteria.value_list,
          limit: 100,
        }],
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async getActiveContactsWithMatches(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/contacts/active/matches`,
      input
    );

    return result.data;
  }

  async getActiveNews(input) {
    if (!input?.news_publication_date_max) {
      input.news_publication_date_max = DateTime.utc().endOf('day').toISO();
    }

    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/news/active`,
      input
    );

    return result.data;
  }

  async getChartContacts(input) {
    const key = `getChartContacts:${btoa(JSON.stringify(input))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination.post(
      `${configuration.api_host}/v1/contacts/organigramme`,
      input
    )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  async getActiveAccounts(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/accounts/active`,
      input
    );

    return result.data;
  }

  async getPressNews(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/news/press`,
      {
        params: input,
      }
    );

    return result.data;
  }

  async getBusinessOpportunityNews(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/news/business-opportunities`,
      {
        params: input,
      }
    );

    return result.data;
  }
}

const search_repository = new SearchRepository();

export {
  search_repository,
};
